/**
 * 
 * key
 * 
 */


const key = 'ZXF1aXBtZW50X2JyYW5k'

export default key 